import React from 'react'
import {
  Button,
  Grid,
  Modal,
  Stack,
  Typography,
  useMediaQuery
} from '@mui/material'
import WarningIcon  from 'shared/assets/icons/warningicon.svg';
import { theme } from '../../../theme/DashboardTheme'
import { selectActiveGrant } from 'shared/redux/product/ProductSlice'
import { useAppSelector } from '../../../redux/storeExports'
import { formatDate } from '../../../utils/helpers'
import { SubscriptionType } from 'shared/redux/product/ProductTypes'

interface AuthLetterRequiredModalProps {
  open: boolean
  setOpen: (open: boolean) => void
  onDowngrade: (sub: SubscriptionType) => Promise<void>
  subscription: SubscriptionType
}

const DowngradeModal = (props: AuthLetterRequiredModalProps) => {
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const grant = useAppSelector(selectActiveGrant)
  return (
    <Modal
      open={props.open}
      sx={{
        backdropFilter: 'blur(5px)',
        background: 'rgba(0, 0, 0, 0.01)',
      }}>
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        sx={{
          outline: 'none',
          position: 'absolute',
          top: '50%',
          left: '50%',
          maxWidth: '600px',
          transform: 'translate(-50%, -50%)',
          width: !isMobile ? '30%' : '80%',
          background: '#fff',
          p: {xs: 5, sm: 6, md: 8},
          borderRadius: '10px',
        }}>
          
        <Stack justifyContent="center" alignItems="center" flexDirection={'column'}>
          <img src={WarningIcon} style={{  width: '8vw', maxWidth: '100px', minWidth: '60px', height: 'auto', }} />
          <Typography 
            variant="h2"
            mt={{xs: 2, sm: 2, md: 3, lg: 3}} 
            textAlign="center"
            sx={{
              fontSize: {xs: 18, md: 21, lg: 23},
              fontWeight: 600,
              lineHeight: {xs: 1, md: 1.2, lg: 1.5},
            }}>
            You&apos;re downgrading your subscription!
          </Typography>
          <Typography 
            variant="body2" 
            textAlign="center" 
            color={'#615F6B'}
            my={{xs: 2, sm: 2, md: 3, lg: 3}} 
            sx={{
              fontSize: {xs: 12, md: 14, lg: 16},
              lineHeight: {xs: 1.2, md: 1.2, lg: 1.5},
              letterSpacing : '0'
            }}>
            The downgrade will take effect at the start of your next billing cycle {grant && `on ${formatDate(grant.grant_expiration)}.`}  
          </Typography>
        </Stack>
        <Grid container rowSpacing={2} mt={1}>
        <Grid item xs={12} sm={12} justifyContent="center" display="flex">
          <Button
            variant={'contained'}
            color={'darkPurple'}
            onClick={()=>{props.onDowngrade(props.subscription)}}
            sx={{
              width: {xs: '90%', sm: '100%', lg: '63%'},
              borderRadius: '10px',
              fontSize: {xs: 8, md: 13, lg: 14},
              boxShadow: 'unset',
              border: '2px solid #9135E0',
              color: '#fff',
              background: '#9135E0',
              '&.Mui-disabled': {
                background: 'transparent',
                color: '#9135E0',
              },
              ':hover': {
                color: '#fff',
                background: '#9135E0',
              },
            }}>
            Confirm Downgrade
          </Button>
        </Grid>
        <Grid item xs={12} sm={12} justifyContent="center" display="flex">
          <Button
            variant={'contained'}
            color={'darkPurple'}
            onClick={()=>props.setOpen(false)}
            sx={{
              width: {xs: '90%', sm: '100%', lg: '63%'},
              borderRadius: '10px',
              fontSize: {xs: 8, md: 13, lg: 14},
              boxShadow: 'unset',
              border: '2px solid #9135E0',
              background: 'transparent',
              color: '#9135E0',
              '&.Mui-disabled': {
                background: 'transparent',
                color: '#9135E0',
              },
              ':hover': {
              background: 'transparent',
              color: '#9135E0',
              },
            }}>
            Cancel
          </Button>
        </Grid>
        </Grid>
      </Grid>
    </Modal>
  )
}

export default DowngradeModal 